import React, { useEffect, useRef, useState } from "react";
import BlockUi from "react-block-ui";
import { withNamespaces } from "react-i18next";
import { withHeaderTitle } from "../../../components/Header/HeaderTitle";
import { getChart } from "../../../services/dashboardServices/serviceProblemGraphics";
import ChartCustom from '../../GoogleChart/ChartCustom'
// estilos.
import "react-block-ui/style.css";
import "../Dashboard.scss";

const ProblemasScreen = (props) => {
  props.setHeaderTitle("Problemas, sueños y temores");
  const isMounted = useRef(false);
  const [blocking, setBlocking] = useState(false);
  const filters = props.filters;
  const onSearch = props.onSearch;
  const setOnSearch = props.setOnSearch;
  // graficos.
  const [columChartP1, setColumChartP1] = useState({ data: [], titles: [] })
  const [columChartP1B, setColumChartP1B] = useState({ data: [], titles: [] })
  const [columChart10Aspiraciones, setColumChart10Aspiraciones] = useState({ data: [], titles: [] })
  const [columChart10Temores, setColumChart10Temores] = useState({ data: [], titles: [] })

  const loadChartP1 = async () => {
    setBlocking(true);
    const data = await getChart({params: filters,method: 'GET',urlApi: 'chart8-primeramencion' });
    const iterableTitles = data.medicionList.reduce((acc, current) => {
      return acc = [ ...acc, `% ${current}`, {role:'annotation'} ]
    }, ['Valores']);
    
    // console.log(data.rows);
    if(isMounted.current) {
      setColumChartP1({ 
        data: data.rows, 
        titles: iterableTitles
      })
    }; 
    
    setBlocking(false);
  }  
  
  const loadChartP1B = async () => {
    setBlocking(true);
    // console.log("Camilo2");
    const data = await getChart({ params: filters, method: 'GET', urlApi: 'chart8-totalmencion' });
    // console.log(data);
    const medicionList = data.medicionList;
    const iterableTitles = medicionList.reduce((acc, current) => {
      return acc = [ ...acc, `% ${current}`, {role:'annotation'} ]
    }, ['Valores']);
    // console.log("1");
    if(isMounted.current) {
      // console.log("2");
      setColumChartP1B({ 
        data: data.rows, 
        titles: iterableTitles
      })
    }
    // console.log("3");
    setBlocking(false);
  }  
  
  const loadChart10Aspiraciones = async () => {
    setBlocking(true);
    const data = await getChart({ params: filters, method: 'GET', urlApi: 'chart10-aspiraciones' });
    const medicionList = data.medicionList;
    const iterableTitles = medicionList.reduce((acc, current) => {
      return acc = [ ...acc, `% ${current}`, {role:'annotation'} ]
    }, ['Valores']);
    
    if(isMounted.current) {
      setColumChart10Aspiraciones({ 
        data: data.rows, 
        titles: iterableTitles
      }); 
    }
    
    setBlocking(false);
  } 
  
  const loadChart10Temores = async () => {
    setBlocking(true);
    const data = await getChart({ params: filters, method: 'GET', urlApi: 'chart10-temores' });
    const medicionList = data.medicionList;
    const iterableTitles = medicionList.reduce((acc, current) => {
      return acc = [ ...acc, `% ${current}`, {role:'annotation'} ]
    }, ['Valores']);
    
    if(isMounted.current) {
      setColumChart10Temores({ 
        data: data.rows, 
        titles: iterableTitles
      }); 
    }
    
    setBlocking(false);
  }

  const loadCharts = () => {
    loadChartP1();
    loadChartP1B();
    loadChart10Aspiraciones();
    loadChart10Temores();
    setOnSearch(false);
  };

  useEffect(() => {
    isMounted.current = true;
    loadCharts();
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if(onSearch){
      loadCharts();
    }
  }, [onSearch]);

  return (
    <BlockUi tag="div" blocking={blocking}>
      {/* Lamina 8 */}
      <div className="row mb-2">
        {columChartP1.data.length > 0 && (
          <ChartCustom  
            subTitle="¿Cuál dirías que es el principal problema que afecta a la región donde vives? - Primera mención" 
            chartCommentJsx={
              <div>
                <p className="mb-0 text-muted">
                  Se omite categoría de respuesta “Otro” y “No sé”.
                </p>
                <p className="mb-0 text-muted">
                  Alternativa “Cambio de Constitución” se evaluó en 2020 como “Reforma a la Constitución”.
                </p>
              </div>
            }
            dataChart={columChartP1.data}
            titles={columChartP1.titles}
            chartConfig={{
              height: '70vh',
              chartArea: { width: "80%", height: '60%' }
            }}
          />
        )}
      </div>
      
      {/* Lamina 8 */}
      <div className="row mb-2">
        {columChartP1B.data.length > 0 && (
          <ChartCustom 
            subTitle="¿Cuál dirías que son los dos principales problemas que afectan a la región donde vives? - Total menciones"
            chartCommentJsx={
              <div>
                <p className="mb-0 text-muted">
                  Se omite categoría de respuesta “Otro” y “No sé”.
                </p>
                <p className="mb-0 text-muted">
                  Alternativa “Cambio de Constitución” se evaluó en 2020 como “Reforma a la Constitución”.
                </p>
              </div>
            }
            dataChart={columChartP1B.data}
            titles={columChartP1B.titles} 
            chartConfig={{
              height: '70vh',
              chartArea: { width: "80%", height: '60%' }
            }}
          />
        )}
      </div>
      
      {/* Lamina 10: Sueños y aspiraciones */}
      <div className="row mb-2">
        {columChart10Aspiraciones.data.length > 0 && (
          <ChartCustom 
            subTitle="Actualmente, ¿Cuáles son tus principales sueños/aspiraciones?"
            chartComment={'Se omite categoría “Otras”.'}
            dataChart={columChart10Aspiraciones.data}
            titles={columChart10Aspiraciones.titles} 
          />
        )}
      </div>
      
      {/* Lamina 10: Temores e incertidumbres */}
      <div className="row mb-2">
        {columChart10Temores.data.length > 0 && (
          <ChartCustom 
            subTitle="¿Y cuáles son tus principales temores/incertidumbres?"
            chartComment={'Se omite categoría “Otras”.'}
            dataChart={columChart10Temores.data}
            titles={columChart10Temores.titles} 
            chartConfig={{
              height: '70vh',
              chartArea: { width: "80%", height: '60%' }
            }}
          />
        )}
      </div>
    </BlockUi>
  );
};

export default withNamespaces("translations")(withHeaderTitle(ProblemasScreen));
